'use client'
import {
  __spreadProps,
  __spreadValues
} from "./chunk-E5AFJQUS.mjs";

// src/shield/HallowShield.tsx
import { jsx } from "react/jsx-runtime";
var HollowShieldIcon = ({ className = "" }) => {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      width: "150",
      height: "170",
      className,
      viewBox: "0 0 150 170",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M75 0.188599L150 25.9698V83.27C150 106.66 140.426 123.515 126.563 136.64C113.459 149.046 96.293 158.302 80.2656 166.945C79.8284 167.18 79.392 167.416 78.9566 167.651L75 169.785L71.0434 167.651C70.608 167.416 70.1717 167.18 69.7345 166.945C53.707 158.302 36.5411 149.046 23.4375 136.64C9.57423 123.515 0 106.66 0 83.27V25.9698L75 0.188599ZM16.6667 37.8646V83.27C16.6667 101.318 23.7591 113.994 34.8958 124.537C45.5303 134.605 59.6016 142.515 75 150.846C90.3984 142.515 104.47 134.605 115.104 124.537C126.241 113.994 133.333 101.318 133.333 83.27V37.8646L75 17.8125L16.6667 37.8646Z",
          fill: "currentColor"
        }
      )
    }
  );
};

// src/shield/Shield.tsx
import { jsx as jsx2, jsxs } from "react/jsx-runtime";
var ShieldIcon = ({ className = "" }) => {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      width: "15",
      height: "16",
      viewBox: "0 0 15 16",
      fill: "none",
      className,
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsx2(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M2.5 2.59968L7.26964 1.70537C7.42189 1.67682 7.57811 1.67682 7.73036 1.70537L12.5 2.59968V7.53922C12.5 9.90966 11.2789 12.1129 9.26874 13.3692L7.83125 14.2676C7.62858 14.3943 7.37142 14.3943 7.16875 14.2676L5.73126 13.3692C3.72113 12.1129 2.5 9.90966 2.5 7.53922L2.5 2.59968Z",
            fill: "#22C55E"
          }
        ),
        /* @__PURE__ */ jsx2(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M6.98438 9.31836C6.83464 9.31836 6.6849 9.25846 6.5651 9.13867L5.36719 7.94076C5.1276 7.70117 5.1276 7.3418 5.36719 7.10221C5.60677 6.86263 5.99609 6.86263 6.20573 7.10221L6.98438 7.88086L8.96094 5.9043C9.20052 5.66471 9.5599 5.66471 9.79948 5.9043C10.0391 6.14388 10.0391 6.50326 9.79948 6.74284L7.40365 9.13867C7.28385 9.25846 7.13411 9.31836 6.98438 9.31836Z",
            fill: "#F0FDF4"
          }
        )
      ]
    }
  );
};

// src/shield/Starred.tsx
import { jsx as jsx3, jsxs as jsxs2 } from "react/jsx-runtime";
var ShieldStarredIcon = (props) => {
  return /* @__PURE__ */ jsxs2(
    "svg",
    __spreadProps(__spreadValues({
      width: "16",
      height: "18",
      viewBox: "0 0 16 18",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [
        /* @__PURE__ */ jsx3(
          "path",
          {
            d: "M15.2999 2.14042L8.23947 0.0222545C8.14061 -0.00741816 8.03522 -0.00741816 7.93635 0.0222545L0.875785 2.14042C0.767165 2.17301 0.671945 2.23975 0.604253 2.33074C0.53656 2.42172 0.500001 2.5321 0.5 2.64551V10.4121C0.5 11.4223 0.908973 12.4564 1.71549 13.4856C2.33146 14.2717 3.18369 15.0611 4.24839 15.8318C6.03704 17.1265 7.79833 17.9208 7.87244 17.9539C7.94022 17.9843 8.01365 18 8.08791 18C8.16218 18 8.23561 17.9843 8.30339 17.9539C8.37746 17.9208 10.1387 17.1265 11.9274 15.8318C12.9921 15.0611 13.8443 14.2717 14.4603 13.4856C15.2668 12.4564 15.6757 11.4223 15.6757 10.4121V2.64551C15.6757 2.5321 15.6391 2.42171 15.5715 2.33072C15.5038 2.23973 15.4085 2.173 15.2999 2.14042Z",
            fill: "#653210"
          }
        ),
        /* @__PURE__ */ jsx3(
          "path",
          {
            d: "M8.50983 4.44559C8.30446 4.01814 7.69454 4.01814 7.48917 4.44559L6.60095 6.29432C6.60095 6.29432 6.59991 6.29575 6.59825 6.29597L4.55464 6.56352C4.08372 6.62517 3.8917 7.20588 4.23959 7.53387L5.73363 8.94248C5.7343 8.94312 5.73424 8.94384 5.73424 8.94384L5.35904 10.9563C5.27149 11.4259 5.76846 11.7807 6.18443 11.5565L7.99741 10.5792C7.99867 10.5785 8.00033 10.5785 8.00159 10.5792L9.81457 11.5565C10.2305 11.7807 10.7275 11.4259 10.64 10.9563L10.2648 8.94384C10.2648 8.94384 10.2647 8.94312 10.2654 8.94248L11.7594 7.53387C12.1073 7.20588 11.9153 6.62517 11.4444 6.56352L9.40075 6.29597C9.39909 6.29575 9.39805 6.29432 9.39805 6.29432L8.50983 4.44559Z",
            fill: "#ffffff"
          }
        )
      ]
    })
  );
};

export {
  HollowShieldIcon,
  ShieldIcon,
  ShieldStarredIcon
};
//# sourceMappingURL=chunk-PZPJQI3R.mjs.map